import { gql } from '@apollo/client'

export default gql(`
query listAppsQuery($module :String!, $project: String!){
    listConfig(
        module: $module,
        project: $project
        ){
            id,
            module,
            project,
            value
        }
}
`)
